import { MIN_PASSWORD_LENGTH } from "./formLimit";

export const NO_ERROR_MESSAGE = " ";

export const AUTH_ERROR_TEXT = {
  EMAIL: {
    WRONG_PATTERN:
      "The email address you entered is not in the correct format.",
    NOT_ACTIVATED: "Account is not activated. Please check your email.",
  },
  PASSWORD: {
    INCORRECT: "The entered password is incorrect. Please try again.",
    SHORT: `Please enter a password of at least ${MIN_PASSWORD_LENGTH} characters.`,
  },
};

export const AUTH_SERVER_ERROR_TYPE = {
  WRONG_PASSWORD: "Password is incorrect",
  NOT_ACTIVATED: "Account is not activated",
  FIRST_STAY_USER_LOGGED_IN: "No Enkoplay user associated with token",
};
